import ApolloErrorBoundary from '@components/ApolloErrorBoundary';
import { type FC, Suspense } from 'react';
import {
  type GateCommonData,
  useGateData,
  type UseGateCommonDataQueryOptions,
  useGateDataForMetricsView,
} from '../hooks/useGateCommonData';

interface Props {
  gateId: string;
  metricsViewId?: string;
  render: FC<GateCommonData>;
  fallback: FC;
  queryOptions?: UseGateCommonDataQueryOptions;
}

export const GateDataRenderer: FC<Props> = (props) => {
  const Fallback = props.fallback;

  return (
    <ApolloErrorBoundary variant="section-alert">
      <Suspense fallback={<Fallback />}>
        {props.metricsViewId !== undefined ? (
          <SuspenseComponentForMetricsView {...props} metricsViewId={props.metricsViewId} />
        ) : (
          <SuspenseComponent {...props} />
        )}
      </Suspense>
    </ApolloErrorBoundary>
  );
};

const SuspenseComponent: FC<Props> = ({ gateId, render: Render, queryOptions }) => {
  const data = useGateData(gateId, queryOptions);
  return <Render {...data} />;
};

const SuspenseComponentForMetricsView: FC<Props & { metricsViewId: string }> = ({
  gateId,
  metricsViewId,
  render: Render,
  queryOptions,
}) => {
  const data = useGateDataForMetricsView(gateId, metricsViewId, queryOptions);
  return <Render {...data} />;
};
